<template>
  <el-dialog
    :visible="value"
    @update:visible="$emit('input', $event)"
    title="发布新文章"
    width="800px"
    :close-on-click-modal="false"
  >
    <el-form 
      ref="form"
      :model="form"
      :rules="rules"
      label-width="80px"
      label-position="top"
    >
      <!-- 文章标题 -->
      <el-form-item label="文章标题：" prop="title">
        <el-input 
          v-model="form.title" 
          placeholder="请输入文章标题（最多50字）"
          maxlength="50"
          show-word-limit
        ></el-input>
      </el-form-item>

      <!-- 文章类型 -->
      <el-form-item label="文章类型：" prop="type">
        <el-select
          v-model="form.type"
          placeholder="请选择文章类型"
          style="width: 100%"
        >
          <el-option
            v-for="item in categories"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>

      <!-- 文章内容 -->
      <el-form-item label="文章内容：" prop="content">
        <el-input
          type="textarea"
          v-model="form.content"
          :rows="5"
          placeholder="请输入文章内容（最多1000字）"
          maxlength="1000"
          show-word-limit
          resize="none"
        ></el-input>
      </el-form-item>

      <!-- 图片上传 -->
      <el-form-item label="图片上传：" prop="images">
        <el-upload
          action=""  
          list-type="picture-card"
          :multiple="true"
          :limit="9"
          :file-list="form.images"
          :on-success="handleUploadSuccess"
          :on-error="handleUploadError"
          :on-exceed="handleExceed"
          :before-upload="beforeUpload"
          accept="image/jpeg,image/png,image/gif"
        >
          <i class="el-icon-plus"></i>
          <div slot="tip" class="upload-tip">
            支持JPG/PNG格式，单张图片不超过5MB，最多上传9张
          </div>
        </el-upload>
      </el-form-item>

      <!-- 审核时间线 -->
      <el-form-item label="审核进度：" v-if="submitStatus !== 'init'">
        <el-timeline>
          <el-timeline-item
            v-for="(status, index) in auditSteps"
            :key="index"
            :icon="status.icon"
            :type="status.type"
            :color="status.color"
            :size="status.size"
            :timestamp="status.timestamp"
          >
            {{ status.content }}
          </el-timeline-item>
        </el-timeline>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button 
        @click="$emit('input', false)" 
        :disabled="submitStatus === 'submitting'"
      >
        取消
      </el-button>
      <el-button 
        type="primary" 
        @click="handleSubmit"
        :loading="submitStatus === 'submitting'"
      >
        {{ submitStatus === 'submitting' ? '提交中...' : '立即提交' }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        title: '',
        type: '',
        content: '',
        images: []
      },
      categories: [
        { value: '1', label: '宠物生活' },
        { value: '2', label: '宠物问答' },
        { value: '3', label: '有趣知识' },
        { value: '4', label: '好物分享' }
      ],
      submitStatus: 'init', // init|submitting|success|fail
      rules: {
        title: [
          { required: true, message: '请输入文章标题', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在2到50个字符', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择文章类型', trigger: 'change' }
        ],
        content: [
          { required: true, message: '请输入文章内容', trigger: 'blur' },
          { min: 10, max: 1000, message: '', trigger: 'blur' }
        ],
        images: [
          { type: 'array', required: false, min: 0, message: '请上传图片', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    auditSteps() {
      const baseSteps = [
        {
          content: '内容提交成功',
          timestamp: this.submitTime,
          type: 'primary',
          icon: 'el-icon-upload',
          color: '#409EFF'
        },
        {
          content: '等待内容审核',
          timestamp: '预计1个工作日',
          type: 'info',
          icon: 'el-icon-time'
        },
        {
          content: '审核结果通知',
          timestamp: '',
          type: 'info',
          icon: 'el-icon-message'
        }
      ]

      if (this.submitStatus === 'success') {
        return baseSteps.map((step, index) => {
          if (index === 1) return {
            ...step,
            content: '内容审核通过',
            type: 'success',
            icon: 'el-icon-check',
            color: '#67C23A'
          }
          return step
        })
      }

      if (this.submitStatus === 'fail') {
        return baseSteps.map((step, index) => {
          if (index === 1) return {
            ...step,
            content: '内容审核未通过',
            type: 'danger',
            icon: 'el-icon-close',
            color: '#F56C6C'
          }
          return step
        })
      }

      return baseSteps
    }
  },
  methods: {
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitStatus = 'submitting'
          this.submitTime = new Date().toLocaleString()
          
          // 模拟提交请求
          setTimeout(() => {
            // 随机模拟成功/失败
            const random = Math.random()
            this.submitStatus = random > 0.3 ? 'success' : 'fail'
            
            if (random > 0.3) {
              this.$message.success('提交成功，进入审核流程')
              this.resetForm()
              this.$emit('input', false)
            } else {
              this.$message.error('提交失败，请稍后重试')
            }
          }, 1500)
        }
      })
    },
    handleUploadSuccess(response, file, fileList) {
      this.form.images = fileList.map(f => ({
        name: f.name,
        url: f.url || URL.createObjectURL(f.raw)
      }))
    },
    handleUploadError() {
      this.$message.error('图片上传失败，请重试')
    },
    handleExceed() {
      this.$message.warning('最多只能上传9张图片')
    },
    beforeUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isLt5M) {
        this.$message.error('图片大小不能超过5MB')
        return false
      }
      return true
    },
    resetForm() {
      this.$refs.form.resetFields()
      this.form.images = []
      this.submitStatus = 'init'
    }
  }
}
</script>

<style scoped>
.upload-tip {
  font-size: 12px;
  color: #909399;
  margin-top: 8px;
}

::v-deep .el-upload--picture-card {
  width: 120px;
  height: 120px;
  line-height: 120px;
}

::v-deep .el-upload-list--picture-card .el-upload-list__item {
  width: 120px;
  height: 120px;
}

.dialog-footer {
  padding: 20px;
  border-top: 1px solid #ebeef5;
  text-align: right;
}

.el-form-item {
  margin-bottom: 24px;
}

.el-timeline {
  padding-left: 10px;
}
</style>